export default function makePDF(pdf: string, filename: string) {
  const byteNumbers = Array.from(pdf).map((_, index) => {
    return pdf.charCodeAt(index)
  })
  const byteArray = new Uint8Array(byteNumbers)
  const file = new Blob([byteArray], {type: "application/pdf;base64"})
  const url = URL.createObjectURL(file)
  const link = document.createElement("a")
  link.setAttribute("href", url)
  link.setAttribute("download", filename)
  link.style.visibility = "hidden"
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
